import http from '@/utils/http'
import { PATH_EDU } from './consts'
import { CourseReq } from './types/course'

// 查询课程列表
export const getCourses = (data: CourseReq) => {
  return http.get(`${PATH_EDU}/v1/courses`, data)
}
// 查询课程列表
type CourseIdReq = {
  course_id: string
  device_sn?: string
}
export const getCourseById = (data: CourseIdReq) => {
  return http.get(`${PATH_EDU}/v1/courses/query`, data)
}

export const getRecordById = (id: string) => {
  return http.get(`${PATH_EDU}/v1/record?session_id=${id}`)
}
